<script setup>
import { cn } from "@/lib/utils";
import { cva } from 'class-variance-authority';
import { Badge } from '@/components/ui/badge';

const tableCellVariants = cva(
    'p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
    {
        variants: {
            variant: {
                default: '',
                metric: 'font-mono tabular-nums text-sm',
                'metric-right': 'font-mono tabular-nums text-sm text-right',
                'metric-badge': 'font-mono tabular-nums text-sm'
            }
        },
        defaultVariants: {
            variant: 'default'
        }
    }
);

const props = defineProps({
    class: { type: null, required: false },
    variant: {
        type: String,
        required: false,
        validator: value => ['default', 'metric', 'metric-right', 'metric-badge'].includes(value)
    }
});
</script>

<template>
  <td
    data-slot="table-cell"
    :class="cn(tableCellVariants({ variant }), props.class)"
  >
    <template v-if="variant === 'metric-badge'">
      <Badge variant="outline">
        <slot />
      </Badge>
    </template>
    <template v-else>
      <slot />
    </template>
  </td>
</template>
